import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/axios'
import { API_ROUTES } from '@/constants/routes'
import { useAuthStore } from '@/stores/useAuthStore'

export interface ShippingConfig {
    id: number
    department: string
    surcharge: string
    estimated_days: number
    is_active: boolean
}

const KEYS = {
    all: ['shipping-config'] as const,
    list: () => [...KEYS.all, 'list'] as const,
}

export function useShippingConfig() {
    const { isLogged } = useAuthStore()
    return useQuery({
        queryKey: KEYS.list(),
        queryFn: async () => {
            const { data } = await api.get<{ results: ShippingConfig[] } | ShippingConfig[]>(API_ROUTES.shippingConfig)
            return Array.isArray(data) ? data : data.results
        },
        enabled: isLogged,
        staleTime: 5 * 60 * 1000,
    })
}
